import { Field, Space } from '@procurify/ui'

import { Tabs } from '@webapp/core/components/Tabs'
import { useLocationHelper, useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useTravelApprovalListView } from './useTravelApprovalListView'
import { WatchlistApproverSelect } from '../../components/WatchlistApproverSelect'
import { ApprovableTravelListPresenter } from '../../features/list-approvable-travels/presenters/ApprovableTravelListPresenter'

export const TravelApprovalListView = () => {
  const intl = useProcurifyIntl()

  const { getQueryString } = useLocationHelper()

  const {
    presenterRef,
    states: {
      status,
      subscribedApproverId,
      justUpdatedId,
      isSelectable,
      hasWatchlistApprovers,
      isSubmitting,
      tabs,
    },
    methods: {
      onApprove,
      onDeny,
      onSelectionChange,
      onCountsChange,
      onWatchlistChange,
    },
  } = useTravelApprovalListView()

  return (
    <>
      <Space direction='horizontal' justify='space-between' align='center'>
        <Tabs>
          {tabs.map((tab) => (
            <Tabs.TabLink
              key={tab.key}
              to={`${tab.to}${getQueryString({ page: 1 })}`}
              count={tab.count}
            >
              {tab.label}
            </Tabs.TabLink>
          ))}
        </Tabs>

        {hasWatchlistApprovers && (
          <Space.Item minWidth={280}>
            <Field
              label={intl.formatMessage(messages.viewingAsLabel)}
              layout='horizontal'
            >
              <WatchlistApproverSelect
                objectType='travel'
                onChange={onWatchlistChange}
              />
            </Field>
          </Space.Item>
        )}
      </Space>

      <ApprovableTravelListPresenter
        ref={presenterRef}
        status={status}
        subscribedApproverId={subscribedApproverId}
        isSelectable={isSelectable}
        justUpdatedId={justUpdatedId}
        disableBulkActions={isSubmitting}
        onSelectionChange={onSelectionChange}
        onCountsChange={onCountsChange}
        onApprove={onApprove}
        onDeny={onDeny}
      />
    </>
  )
}

TravelApprovalListView.displayName = 'TravelApprovalListView'
